"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var form_store_1 = __importDefault(require("../stores/form_store"));
var WNumber_1 = __importDefault(require("../component/WNumber"));
var WBirthday_1 = __importDefault(require("../component/WBirthday"));
var IsAddressChange_1 = __importDefault(require("../component/IsAddressChange"));
var Email_1 = __importDefault(require("../component/Email"));
var Treatments_1 = __importDefault(require("../component/Treatments"));
var Outcome_1 = __importDefault(require("../component/Outcome"));
var Submit_1 = __importDefault(require("../component/Submit"));
var ReportOfChildbirth_1 = __importDefault(require("./ReportOfChildbirth"));
var InfantInformation_1 = __importDefault(require("./InfantInformation"));
var AbortionInformation_1 = __importDefault(require("./AbortionInformation"));
;
;
var FirstStep = /** @class */ (function (_super) {
    __extends(FirstStep, _super);
    function FirstStep(props) {
        var _this = _super.call(this, props) || this;
        var state = form_store_1.default.getState();
        _this.state = {
            outcome: state.data.outcome
        };
        _this._isMounted = false;
        form_store_1.default.on("STATE_CHANGE", function () {
            var state = form_store_1.default.getState();
            if (_this._isMounted) {
                _this.setState({
                    outcome: state.data.outcome
                });
            }
        });
        return _this;
    }
    FirstStep.prototype.componentDidMount = function () {
        this._isMounted = true;
    };
    FirstStep.prototype.componentWillUnmount = function () {
        this._isMounted = false;
    };
    FirstStep.prototype.render = function () {
        var sec2content = (react_1.default.createElement(react_1.default.Fragment, null)), sec3content = (react_1.default.createElement(react_1.default.Fragment, null));
        if (this.state.outcome.indexOf("1") > -1 || this.state.outcome.indexOf("2") > -1) {
            sec2content = (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "form__section" },
                    react_1.default.createElement(ReportOfChildbirth_1.default, null)),
                react_1.default.createElement("div", { className: "form__section" },
                    react_1.default.createElement(InfantInformation_1.default, null))));
        }
        if (this.state.outcome.indexOf("3") > -1) {
            sec3content = (react_1.default.createElement(AbortionInformation_1.default, null));
        }
        return (react_1.default.createElement("form", { name: "form", method: "POST", action: ".", className: "form" },
            react_1.default.createElement("div", { className: "form__container" },
                react_1.default.createElement("p", { className: "form__message" }, "\u30FB\uFF0A\u5370\u306E\u9805\u76EE\u306F\u5FC5\u9808\u9805\u76EE\u3067\u3059\u3002"),
                react_1.default.createElement("p", { className: "form__message" }, "\u30FB\u203B \u6570\u5B57\u306F\u5168\u3066\u534A\u89D2\u3067\u3054\u5165\u529B\u304F\u3060\u3055\u3044\u3002"),
                react_1.default.createElement("div", { className: "form__block" },
                    react_1.default.createElement("div", { className: "form__item" },
                        react_1.default.createElement("div", { className: "form__title" },
                            react_1.default.createElement("label", { htmlFor: "card-no", className: "form__label" }, "\u59BB\u8A3A\u5BDF\u5238\u756A\u53F7"),
                            react_1.default.createElement("span", { className: "form__required" }, "\uFF0A")),
                        react_1.default.createElement("div", { className: "form__input" },
                            react_1.default.createElement(WNumber_1.default, null))),
                    react_1.default.createElement("div", { className: "form__item" },
                        react_1.default.createElement("fieldset", { className: "form__field" },
                            react_1.default.createElement("legend", { className: "form__title" },
                                react_1.default.createElement("span", { className: "form__label" }, "\u59BB\u751F\u5E74\u6708\u65E5"),
                                react_1.default.createElement("span", { className: "form__required" }, "\uFF0A")),
                            react_1.default.createElement("div", { className: "form__input" },
                                react_1.default.createElement(WBirthday_1.default, null)))),
                    react_1.default.createElement("div", { className: "form__item" },
                        react_1.default.createElement("fieldset", { className: "form__field" },
                            react_1.default.createElement("legend", { className: "form__title" },
                                react_1.default.createElement("span", { className: "form__label" }, "\u4F4F\u6240\u5909\u66F4\u306B\u3064\u3044\u3066"),
                                react_1.default.createElement("span", { className: "form__required" }, "\uFF0A")),
                            react_1.default.createElement("div", { className: "form__input" },
                                react_1.default.createElement(IsAddressChange_1.default, null)))),
                    react_1.default.createElement("div", { className: "form__item" },
                        react_1.default.createElement("div", { className: "form__title" },
                            react_1.default.createElement("label", { htmlFor: "email", className: "form__label" }, "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9"),
                            react_1.default.createElement("span", { className: "form__required" }, "\uFF0A")),
                        react_1.default.createElement("div", { className: "form__input" },
                            react_1.default.createElement(Email_1.default, null))),
                    react_1.default.createElement("div", { className: "form__item" },
                        react_1.default.createElement("div", { className: "form__title" },
                            react_1.default.createElement("label", { htmlFor: "treatment-method", className: "form__label" }, "\u598A\u5A20\u306B\u81F3\u3063\u305F\u6CBB\u7642\u65B9\u6CD5"),
                            react_1.default.createElement("span", { className: "form__required" }, "\uFF0A")),
                        react_1.default.createElement("div", { className: "form__input" },
                            react_1.default.createElement(Treatments_1.default, null))),
                    react_1.default.createElement("div", { className: "form__item" },
                        react_1.default.createElement("fieldset", { className: "form__field" },
                            react_1.default.createElement("legend", { className: "form__title" },
                                react_1.default.createElement("span", { className: "form__label" }, "\u598A\u5A20\u306E\u8EE2\u5E30"),
                                react_1.default.createElement("span", { className: "form__required" }, "\uFF0A")),
                            react_1.default.createElement("div", { className: "form__input" },
                                react_1.default.createElement(Outcome_1.default, null)))))),
            sec2content,
            sec3content,
            react_1.default.createElement(Submit_1.default, null)));
    };
    return FirstStep;
}(react_1.Component));
exports.default = FirstStep;
;
